export const accessPriority = {
  Disable: 0,
  Read: 1,
  ReadWrite: 2,
};
